// import external dependencies
import $ from 'jquery';
//import 'bootstrap';

// Import just what we need
// https://getbootstrap.com/docs/5.0/customize/optimize/

// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

// and import just when we use \o/
//$(window).on('load', function(){
/*$(document).ready(function(){
  const btnModal = document.querySelector(".btn-modal");
  btnModal.addEventListener("click", openModal);

  async function openModal(event) {
    event.preventDefault();
    await import('bootstrap/js/dist/modal').then(module => {
      console.log('here');
      jQuery(".modal").modal();
    });

  };
});*/

// MODERNIZR for detect webp images browser support
// https://modernizr.com/download?webp-setclasses&q=webp
Modernizr.on('webp', function (result) {
  if (result) {
    // supported
  } else {
    // not-supported
  }
});

//Custom Libs
import "./custom-libs/fontawesome.js";
import "./custom-libs/slick.js";
/*import "./aos.js";
import "./mobile-menu.js";
import "./leaflet.js";
import "./rellax.js";
import "./animation.js";
import "./utilities.js";
import "./stylish.js";*/
